import { Edit } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Badge } from '@/components/ui/Badge';
import { Button } from '@/components/ui/Button';
import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from '@/components/ui/Table';
import { User } from '@/services/UserService';

interface UsersTableProps {
  users: User[];
  isLoading: boolean;
}

export function UsersTable({ users, isLoading }: UsersTableProps) {
  const navigate = useNavigate();

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>ID</TableHead>
          <TableHead>Name</TableHead>
          <TableHead>Email</TableHead>
          <TableHead>Role</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Customer</TableHead>
          <TableHead className="text-center">Actions</TableHead>
        </TableRow>
      </TableHeader>

      <TableBody>
        {isLoading &&
          [...Array(5)].map((_, index) => (
            <TableRow key={index}>
              <TableCell colSpan={6}>
                <div className="h-4 w-full animate-pulse rounded bg-gray-200" />
              </TableCell>
            </TableRow>
          ))}

        {!isLoading &&
          users.map((user) => (
            <TableRow key={user.id} className="hover:bg-gray-100">
              <TableCell>{user.id}</TableCell>

              <TableCell>
                {user.firstName} {user.lastName}
              </TableCell>

              <TableCell>{user.email}</TableCell>

              <TableCell>{user.role.name}</TableCell>

              <TableCell>
                <Badge
                  variant={
                    user.status.name === 'Active'
                      ? 'default'
                      : user.status.name === 'Inactive'
                        ? 'secondary'
                        : 'outline'
                  }
                >
                  {user.status.name}
                </Badge>
              </TableCell>

              <TableCell>
                {user?.customer?.name ?? 'N/A'}{' '}
                {user?.customer?.id && <span>({user.customer.id})</span>}
              </TableCell>

              <TableCell className="text-center">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => navigate(`/admin/users/edit/${user.id}`)}
                >
                  <Edit className="h-4 w-4" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}
